module.exports = __webpack_public_path__ + "img/Frame 5138.63d6286d.jpg";